var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrophonePermission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 60,
    viewBox: "0 0 50 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0002 5.45455C20.3694 5.45455 16.6155 9.11768 16.6155 13.6364V24.5455C16.6155 29.0643 20.3694 32.7273 25.0002 32.7273C29.6306 32.7273 33.3847 29.0643 33.3847 24.5455V13.6364C33.3847 9.11768 29.6306 5.45455 25.0002 5.45455ZM25.0002 0C32.7178 0 38.9744 6.10522 38.9744 13.6364V24.5455C38.9744 32.0765 32.7178 38.1818 25.0002 38.1818C17.2823 38.1818 11.0258 32.0765 11.0258 24.5455V13.6364C11.0258 6.10522 17.2823 0 25.0002 0ZM0 27.2727H5.63429C6.99043 36.5245 15.1441 43.6364 25.0002 43.6364C34.8559 43.6364 43.0095 36.5245 44.3659 27.2727H50C48.7113 38.6498 39.454 47.6834 27.795 48.9412V60H22.2053V48.9412C10.5462 47.6834 1.28884 38.6498 0 27.2727Z",
    fill: "#516CD3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophonePermission);
export default __webpack_public_path__ + "static/media/MicrophonePermission.c4731766d7f935e04f1c59f5dafb060e.svg";
export { ForwardRef as ReactComponent };